import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { Box, Card, CardContent, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@material-ui/core';

const OVERVIEW_QUERY = gql`
  query AdminPlanBuilderOverviewReport {
    adminPlanBuilderOverviewReport {
      metrics {
        total_started
        active_count
        paused_count
        completed_count
        completion_rate
        median_completion_percentage_active
        avg_time_to_complete_seconds
        upcoming_resumes_next_24h
        reminder_status_scheduled
        reminder_status_failed
        reminder_status_disabled
      }
      by_template {
        planTemplate {
          id
          name
          slug
          planType
          status
        }
        started_count
        in_progress_count
        paused_count
        completed_count
        completion_rate
      }
    }
  }
`;

const pct = (v) => `${Math.round((v || 0) * 1000) / 10}%`;

const PlanBuilderOverviewReport = () => {
  const { data, loading, error } = useQuery(OVERVIEW_QUERY, { fetchPolicy: 'cache-and-network' });
  const report = data?.adminPlanBuilderOverviewReport;
  const m = report?.metrics;
  const rows = report?.by_template || [];

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>Plan Builder Overview</Typography>

      {error && <Typography color="error">Error: {error.message}</Typography>}
      {loading && <Typography color="textSecondary">Loading...</Typography>}

      {m && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <Card><CardContent>
              <Typography color="textSecondary" variant="subtitle2">Started</Typography>
              <Typography variant="h5">{m.total_started}</Typography>
            </CardContent></Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card><CardContent>
              <Typography color="textSecondary" variant="subtitle2">Active</Typography>
              <Typography variant="h5">{m.active_count}</Typography>
            </CardContent></Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card><CardContent>
              <Typography color="textSecondary" variant="subtitle2">Paused</Typography>
              <Typography variant="h5">{m.paused_count}</Typography>
            </CardContent></Card>
          </Grid>
          <Grid item xs={12} md={3}>
            <Card><CardContent>
              <Typography color="textSecondary" variant="subtitle2">Completed</Typography>
              <Typography variant="h5">{m.completed_count}</Typography>
              <Typography variant="body2" color="textSecondary">Completion rate: {pct(m.completion_rate)}</Typography>
            </CardContent></Card>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">
              Upcoming resumes (24h): {m.upcoming_resumes_next_24h} • Reminder health: scheduled {m.reminder_status_scheduled} • failed {m.reminder_status_failed} • disabled {m.reminder_status_disabled}
            </Typography>
          </Grid>
        </Grid>
      )}

      <Box mt={3}>
        <Typography variant="h6" gutterBottom>By template</Typography>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Template</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Type</TableCell>
                <TableCell align="right">Started</TableCell>
                <TableCell align="right">In progress</TableCell>
                <TableCell align="right">Paused</TableCell>
                <TableCell align="right">Completed</TableCell>
                <TableCell align="right">Completion rate</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r) => (
                <TableRow key={r.planTemplate.id} hover>
                  <TableCell>{r.planTemplate.name}</TableCell>
                  <TableCell>{r.planTemplate.status}</TableCell>
                  <TableCell>{r.planTemplate.planType}</TableCell>
                  <TableCell align="right">{r.started_count}</TableCell>
                  <TableCell align="right">{r.in_progress_count}</TableCell>
                  <TableCell align="right">{r.paused_count}</TableCell>
                  <TableCell align="right">{r.completed_count}</TableCell>
                  <TableCell align="right">{pct(r.completion_rate)}</TableCell>
                </TableRow>
              ))}
              {!rows.length && !loading && (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Typography color="textSecondary">No data.</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default PlanBuilderOverviewReport;


